import type {BulkUpdateErrorKey} from 'services/bulkUpdates/types';
import {BulkUpdateErrorKeys} from 'services/bulkUpdates/types';

export const isBulkUpdateErrorKey = (
  value: unknown,
): value is BulkUpdateErrorKey => {
  return !!value && BulkUpdateErrorKeys.includes(value as BulkUpdateErrorKey);
};
